'use strict'

export class SessionService {
  constructor(UserService, $sessionStorage, $localStorage, $http, $q) {
    'ngInject'
    Object.assign(this, { UserService, $sessionStorage, $localStorage, $http, $q })
  }

  save(key, value) {
    this.$sessionStorage[key] = value
  }

  savePermanent(key, value) {
    this.$localStorage[key] = value
  }

  get(key) {
    return this.$sessionStorage[key] || this.$localStorage[key] || undefined
  }

  clear() {
    this.$sessionStorage.$reset()
    this.$localStorage.$reset()
  }

  isAuthenticated() {
    return this.get('token') && this.currentUser
  }

  authenticateByToken() {
    return this.UserService.me().then((user) => {
      this.currentUser = user
      return user
    })
  }

  authenticateByCredentials(credentials) {
    return this.$http({
      method: 'POST',
      url: '/api/companies/0/sessions',
      data: credentials,
    }).then((res) => {
      this.save('token', res.data.token)
      return this.authenticateByToken()
    })
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/session.service.js